/** @jsx isolateComponent */
import { Colors } from '@zapier/theme';
import { isolateComponent, labelStyles } from '@zapier/common-utils';

const Styles = labelStyles(__filename, {
  root: {
    backgroundColor: Colors.grey200,
    borderRadius: '5px',
    height: '3px',
    width: '40px',
  },
});

/**
 * A visual divider used between UI components.
 */
const Divider = () => <div css={Styles.root} />;

export default Divider;
